
// eslint-disable-next-line import/prefer-default-export
export const listDriverStates = {
  data: () => ({
    driverStates: [],
    driverStatesLoading: true,
  }),
  watch: {
    driverStates() {
      this.driverStatesLoading = false;
    },
  },
  methods: {
    async listDriverStates() {
      this.driverStatesLoading = true;
      const { data } = await this.$store.dispatch('driverStates/getDriverStates', {});
      if (data) {
        this.driverStates = data;
      }
    },
  },
};
